import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=c81d8fc2&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&id=c81d8fc2&prod&lang=scss&scoped=true&"
import style1 from "./Create.vue?vue&type=style&index=1&id=c81d8fc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d8fc2",
  null
  
)

export default component.exports